import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcCtntLstInqApi = async (
    gameSvcCd:string|null,
    ctntKindCd:string|null,
    nowPageNo:string|number|null,
    srchStr:string|null,
    ctntCtgrCd:string|null,
) => {
    return await CommApiInstance.post(`${gameSvcCd}/ctnt/ctnt_lst?page=${nowPageNo}&srch=${srchStr}`,{
        apiBody:{
            ctntKindCd:ctntKindCd,
            ctntCtgrCd:ctntCtgrCd,
        }
    })
    .then((Resp) => Resp.data);
}
export default GameSvcCtntLstInqApi;